module.exports = __webpack_public_path__ + "img/ms_my.7fc8b2c7.png";